export const BRAND_NAME = 'Playwin111com';
export const BRAND_DOMAIN = 'playwin111.com';
export const PROVIDER_ID = 'BetFair';
export const BACKEND_DOMAIN = 'newhyp2025.co';
